import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import SkillEditForm from './SkillEditForm';
import SkillList from './SkillList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import SkillListView from './SkillListView'


export default function SkillDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.skillDashboard);
  const [ skillId, setSkillId] = React.useState('');
  const [reloadSkillList, setReloadSkillList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <SkillEditForm 
            setReloadSkillList={setReloadSkillList}
            skillId={skillId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <SkillListView 
                      setSkillId = {setSkillId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
